import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["map", "drawer", "toggleButton", "toggleText"]

  connect() {
    // On mobile, start with map view
    if (window.innerWidth < 992) {
      this.showMap()
    }
  }

  toggleView() {
    if (this.drawerTarget.classList.contains('active')) {
      this.showMap()
    } else {
      this.showList()
    }
  }

  showMap() {
    this.drawerTarget.classList.remove('active')
    this.toggleTextTarget.textContent = 'Show List'
    this.toggleButtonTarget.querySelector('i').classList.remove('fa-map')
    this.toggleButtonTarget.querySelector('i').classList.add('fa-list')
  }

  showList() {
    this.drawerTarget.classList.add('active')
    this.toggleTextTarget.textContent = 'Show Map'
    this.toggleButtonTarget.querySelector('i').classList.remove('fa-list')
    this.toggleButtonTarget.querySelector('i').classList.add('fa-map')
  }
}
